import { DOTHelper } from 'lib/dot/DOTHelper.ts';
import type { PageType } from 'lib/dot/enum/pageType.ts';
import { getBazarUrlParams } from 'lib/dot/utils/routeParams.ts';

export type BazarImpression = {
	itemCount: number;
	pageType: typeof PageType.SEARCH_RESULTS_SELLER | typeof PageType.SEARCH_RESULTS_SELLER_SELF;
	routeParamShopSeo?: string;
	routeParamSort?: string;
	routeParamStrana?: string;
};

export function sendBazarImpression(itemCount: number) {
	// #if [DEV]
	DOTHelper.checkStore(['pageType']);
	// #endif

	const store = DOTHelper.getStore();

	const data: BazarImpression = {
		itemCount,
		pageType: store.pageType,
		...getBazarUrlParams(),
	};

	DOTHelper.impress(data);
}
